export default () => ({
    isLoading: false,
    loaded: false,
    list: [],
    total: 0
})
